import * as reduxForm from 'redux-form';
export const createGetFormValuesSelector = (form) => reduxForm.getFormValues(form);
